// src/i18n/known-languages.js
import * as langs from "langs";

export const curatedLanguages = {
  en: "English",
};

export const getNativeLabel = (code) => {
  const c = (code ?? "").toString().trim().toLowerCase();
  const entry = langs.where("1", c);
  return entry?.local || c.toUpperCase();
};

export const isoLanguages = langs
  .codes("1")
  .map((code) => {
    const entry = langs.where("1", code);
    return [code, entry.local || entry.name]; // fallback to English if no local name
  })
  .sort((a, b) => a[1].localeCompare(b[1])); // sort by native name

export const getUnusedLanguages = (usedLangs) =>
  isoLanguages.filter(([code]) => !usedLangs.includes(code));
